'use es6';

import { PUBLIC_FEATURE_FLAGS_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
const initialState = {};

const PublicFeatureFlags = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case PUBLIC_FEATURE_FLAGS_RECEIVED:
      {
        const {
          featureFlags
        } = payload;
        return featureFlags;
      }

    default:
      return state;
  }
};

export default PublicFeatureFlags;